import React from "react";
import {Select} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {observer} from "mobx-react";
import {useTranslate} from "../../hooks/translate.hook";
import {RootStoreContext} from "../../stores/root/root.store";
import {useRequiredStore} from "../../utils/store";

export const AppLanguageSelect: React.FC = observer(() => {
    const t = useTranslate();
    const {langStore} = useRequiredStore(RootStoreContext);

    return (
        <Select<string>
            className="app-language-select"
            showSearch
            optionFilterProp="children"
            onChange={(value) => void t.i18n.changeLanguage(value)}
            value={t.i18n.language}
            suffixIcon={<FontAwesomeIcon icon={["fas", "language"]} />}
        >
            {langStore.locales.map((locale) => (
                <Select.Option key={locale} value={locale}>
                    {locale.toUpperCase()}
                </Select.Option>
            ))}
        </Select>
    );
});
